<script>
import { mapGetters } from 'vuex';
import { uniq, find, filter } from 'lodash';

export default {
  name: 'SelectModeCamion',
  props: {
    value: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    libelle: null,
    option: undefined,
    initialized: false
  }),
  computed: {
    ...mapGetters({ ref: 'referentiel/referentiel' }),
    modesCamion () {
      return uniq(this.ref.modesCamion.map(m => m.libelle));
    },
    options () {
      return filter(this.ref.modesCamion, { libelle: this.libelle }).map(i => i.libelleOption).filter(l => !!l);
    },
    selectedValue () {
      // eslint-disable-next-line eqeqeq
      let mode = this.ref.modesCamion.filter(m => m.libelle === this.libelle && m.libelleOption == this.option)[0];
      if (!mode) {
        mode = this.ref.modesCamion.filter(m => m.libelle === this.libelle && m.libelleOption === undefined)[0];
      }
      return mode;
    },
    _undefined () {
      return undefined;
    }
  },
  watch: {
    selectedValue () {
      this.onChange();
    },
    value () {
      this.updateValue();
    }
  },
  created () {
    let value = find(this.ref.modesCamion, { code: this.value });
    if (!value) {
      value = find(this.ref.modesCamion, { code: 'VIS' });
    }
    if (value) {
      this.libelle = value.libelle;
      this.option = value.libelleOption;
      setTimeout(() => this.onChange());
    }
  },
  methods: {
    updateValue () {
      const value = find(this.ref.modesCamion, { code: this.value });
      if (value) {
        this.libelle = value.libelle;
        this.option = value.libelleOption;
      }
    },
    onChange () {
      this.$emit('input', this.selectedValue.code);
    }
  }
};
</script>

<template>
  <fragment>
    <v-select
      v-model="libelle"
      :items="modesCamion"
      label="Mode camion *"
      prepend-icon="mdi-truck"
      :error-messages="rules"
    />
    <div>
      <v-checkbox
        v-for="optionStr in options"
        :key="optionStr"
        v-model="option"
        color="primary"
        :label="optionStr"
        :true-value="optionStr"
        :false-value="null"
        :error-messages="rules"
        hide-details
        class="_checkbox"
      />
    </div>
  </fragment>
</template>

<style lang="scss" scoped>
._checkbox {
  margin: 0;
  padding: 0;
}
</style>
